<template>
    <normal-page name="Reviews">
        <div class="flex flex-col gap-y-6">
            <div
                v-for="reviews in groupedReviews"
                :key="reviews.name"
                class="panel flex flex-col gap-6 p-5 transition-colors duration-300 hover:border-foam/15 sm:flex-row sm:gap-8 sm:p-7"
            >
                <div class="shrink-0">
                    <v-lazy-image
                        :src="getImageSrc(reviews.name)"
                        class="image-glow w-[15rem] max-w-full"
                    />

                    <div
                        v-text="reviews.name"
                        class="mt-4 font-serif text-xl font-light italic tracking-wide"
                    />
                </div>

                <div class="flex flex-col gap-y-3">
                    <div
                        v-for="(review, i) in reviews.reviews"
                        :key="i"
                        class="clickable border-l border-foam/10 pl-5 transition-colors hover:border-foam/40"
                    >
                        <review-component :review="review" />
                    </div>
                </div>
            </div>
        </div>
    </normal-page>
</template>

<script>
    // Components
    import { defineComponent } from 'vue';
    import NormalPage from '@/components/layout/pages/NormalPage';
    import ReviewComponent from '@/components/layout/ReviewComponent';
    // Library
    import store from '@/store/store';
    import VLazyImage from 'v-lazy-image';

    export default defineComponent({
        name: 'ReviewsView',

        components: {
            VLazyImage,
            NormalPage,
            ReviewComponent,
        },

        setup() {
            const getImageSrc = (name) => `img/releases/${name.toLowerCase().replace(' ', '_')}-240.jpg`;

            return {
                groupedReviews: store.getters.groupedReviews,
                getImageSrc,
            };
        },
    });
</script>
